import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data";

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 md:py-28 surface-a">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E63946]">Testimonials</p>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-steel">
            What our customers say
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TESTIMONIALS.map((t, idx) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-card-${idx}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.06 }}
              className="relative rounded-2xl card-grey elev border border-white/10 p-6 hover:-translate-y-1 hover:border-white/25 transition-all duration-300"
            >
              <Quote className="w-8 h-8 text-[#E63946]/40" />
              <div className="flex items-center gap-1 text-[#F59E0B] mt-3">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="mt-4 text-gray-200 leading-relaxed">"{t.text}"</p>
              <div className="mt-5 pt-4 border-t border-white/10">
                <p className="font-semibold text-white">{t.name}</p>
                <p className="text-sm text-gray-400">{t.location}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
